import React, { useRef, useState } from "react";
import CloudinaryAdvancedImage from '@common/utils/CloudinaryAdvancedImage';
import PlayButton from '@commonComponents/PlayButton';
import CsrLogo from '@common/assets/images/csr/project_siksha_logo.png';

const CsrHero = () => {
  const videoRef = useRef(null);
  const [isPlaying, setIsPlaying] = useState(false);
  const [showControls, setShowControls] = useState(false);

  const handlePlayClick = () => {
    if (videoRef.current) {
      if (isPlaying) {
        videoRef.current.pause();
        setIsPlaying(false);
      } else {
        videoRef.current.play();
        setIsPlaying(true);
        setShowControls(true);
      }
    }
  };

  const handleVideoPlay = () => {
    setIsPlaying(true);
    setShowControls(true);
  };

  const handleVideoPause = () => {
    setIsPlaying(false);
  };

  return (
    <div className="bs-section bs-section--typ-csr-hero">
      <div className="bs-section__section-cont">
        <div className="bs-csr-hero-layout">
          {/* Top Section - Logo and Text Content */}
          <div className="bs-csr-hero-layout__top-section">
            <div className="bs-csr-hero-layout__left-content">
              <img 
                src={CsrLogo} 
                alt="Project Shiksha - Creating a better tomorrow, today" 
                className="bs-csr-hero-layout__logo"
              />
            </div>
            <div className="bs-csr-hero-layout__right-content">
              <h1 className="bs-csr-hero-layout__intro">AT SANSAAR,</h1>
              <h2 className="bs-csr-hero-layout__main-title">
                We believe that every child deserves a safe nurturing, and inspiring environment to learn and grow.
              </h2>
              <p className="bs-csr-hero-layout__description">
                Through Project Shiksha, we focus on enhancing school infrastructure and ensuring access to essential resources that support a holistic learning experience. With Project Shiksha, we are not just building schools; we are building futures.
              </p>
              <p className="bs-csr-hero-layout__mission">
                Our mission is to create meaningful change by empowering children through education and better learning environments.
              </p>
            </div>
          </div>

          {/* Bottom Section - Video */}
          <div className="bs-csr-hero-layout__bottom-section">
            <div className={`bs-csr-hero-layout__video-container ${isPlaying ? 'playing' : ''}`}>
              <video
                ref={videoRef}
                className="bs-csr-hero-layout__video"
                poster="https://res.cloudinary.com/dci1aiukm/image/upload/q_auto/f_webp/video_cover"
                preload="metadata"
                {...(showControls && { controls: true })}
                onPlay={handleVideoPlay}
                onPause={handleVideoPause}
              >
                <source src="https://res.cloudinary.com/dci1aiukm/video/upload/v1761546095/sansaar_csr_video_hero.mp4" type="video/mp4" />
                Your browser does not support the video tag.
              </video>
              {!isPlaying && (
                <div
                  className="bs-csr-hero-layout__play-icon"
                  onClick={handlePlayClick}
                  role="button"
                  tabIndex={0}
                  aria-label="Play video"
                  onKeyDown={(e) => {
                    if (e.key === "Enter" || e.key === " ") {
                      e.preventDefault();
                      handlePlayClick();
                    }
                  }}
                >
                  <PlayButton size="large" />
                </div>
              )}
            </div>
          </div>

          {/* Gallery Section - Three Images */}
          <div className="bs-csr-hero-layout__gallery-section">
            <div className="bs-csr-hero-layout__gallery-grid">
              <div className="bs-csr-hero-layout__gallery-item">
                <CloudinaryAdvancedImage
                  imagePublicId="20240128_055342260_iOS"
                  altText="Students at Project Shiksha supported school"
                  className="bs-csr-hero-layout__gallery-image"
                  type="by3"
                />
              </div>
              <div className="bs-csr-hero-layout__gallery-item">
                <CloudinaryAdvancedImage
                  imagePublicId="20240402_225014790_iOS"
                  altText="Group of students with new school supplies"
                  className="bs-csr-hero-layout__gallery-image"
                  type="by3"
                />
              </div>
              <div className="bs-csr-hero-layout__gallery-item">
                <CloudinaryAdvancedImage
                  imagePublicId="20240820_070341000_iOS"
                  altText="Renovated classroom with educational materials"
                  className="bs-csr-hero-layout__gallery-image"
                  type="by3"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CsrHero;
